import clsx from 'clsx';
import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { normalizeSpaceTitle, SPACE_TITLE_LIMIT } from '@gitbook/app-database';
import { InlineInputEdit, toast } from '@gitbook/spine-react';

import { apiClient } from '../../../state';

/**
 * Editable title for the space
 */
export function SpaceTitle(props: {
    space: api.Space;
    editable: boolean;
    size: 'small' | 'medium';
}): React.ReactElement {
    const { space, editable, size } = props;
    const readOnly = !editable || !space.permissions.admin;

    return (
        <div className="flex w-full flex-1 items-start">
            <InlineInputEdit
                kind="highlighted"
                className={clsx(
                    {
                        medium: 'px-2 text-ui-heading-large',
                        small: 'px-1 text-ui-action',
                    }[size]
                )}
                readOnly={readOnly}
                value={space.title}
                placeholder="Untitled"
                maxLength={SPACE_TITLE_LIMIT}
                onSave={async (value, { reset }) => {
                    const title = normalizeSpaceTitle(value);

                    if (title === space.title) {
                        reset();
                        return;
                    }

                    await toast.catch(async () => {
                        try {
                            await apiClient.spaces.updateSpaceById(space.id, {
                                title,
                            });
                        } catch (error) {
                            reset();
                            throw error;
                        }
                    }, 'Error while updating space title');
                }}
            />
        </div>
    );
}
